import React from 'react';
import './TodosError.css'


function TodosError() {
  return (
    <p>Se presentó un error 🚧</p>
  )
}

export { TodosError }